export default __webpack_public_path__ + "static/media/shop_2.2d8398b2.gif";